export { ReactComponent as UploadCloudIcon } from './feather_upload-cloud.svg';
